<template>
<div class="userHeaderIcon inline-block text-center"
     :style="{
       width: `${props.width}px`,
       height:`${props.width}px`,
       fontSize: `${props.fontSize}`,
       lineHeight: `${props.width - 2}px`}
     ">
  {{text}}
</div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue'
const props = defineProps({
  width: {
    type: [
      String,
      Number,
    ],
    'default': 20,
  },
  text: {
    type: String,
    'default': '',
  },
  fontSize: {
    type: String,
    'default': '14px',
  },
})
</script>
<style scoped lang="scss">
.userHeaderIcon{
  border-radius: 100px;
  background-color: #4F6999;
  color:#ffffff;
}
</style>
